'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _domready = require('domready');

var _domready2 = _interopRequireDefault(_domready);

var _tocss = require('./tocss');

var _tocss2 = _interopRequireDefault(_tocss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window:true document:true */


function memoize(fn) {
  var memo = void 0;
  return function memofiy() {
    if (memo == null) memo = fn();
    return memo;
  };
}

var getHeadElement = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});
var previousGlobalStyleElement = null;

function beautifulClassName(componentName, id) {
  return componentName.toLowerCase() + id.replace('node_', '-');
}

function insertStyleElement(styleElement) {
  getHeadElement().appendChild(styleElement);
}

function _createStyleElement() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var styleElement = document.createElement('style');
  styleElement.type = 'text/css';
  styleElement.setAttribute('from', from);
  insertStyleElement(styleElement);
  return styleElement;
}

function removeGlobalCss() {
  if (previousGlobalStyleElement) {
    previousGlobalStyleElement.parentNode.removeChild(previousGlobalStyleElement);
    previousGlobalStyleElement = null;
  }
}

function writeGlobalCss(css) {
  removeGlobalCss();
  previousGlobalStyleElement = _createStyleElement('render-engine');
  if (previousGlobalStyleElement.styleSheet) {
    previousGlobalStyleElement.styleSheet.cssText = css;
  } else {
    previousGlobalStyleElement.appendChild(document.createTextNode(css));
  }
}

var StyleProcessor = function () {
  function StyleProcessor() {
    var _this = this;

    _classCallCheck(this, StyleProcessor);

    this.cssCollection = [];
    this.readyTask = [];
    this.isReady = false;
    if (getHeadElement()) {
      this.prepare();
    } else {
      (0, _domready2.default)(function () {
        return _this.prepare();
      });
    }
  }

  StyleProcessor.prototype.setNamespace = function setNamespace(namespace) {
    // this.namespace = namespace;
  };

  StyleProcessor.prototype.setDesignMode = function setDesignMode(flag) {
    this.designMode = flag;
  };

  StyleProcessor.prototype.isDesignMode = function isDesignMode() {
    return this.designMode;
  };

  StyleProcessor.prototype.prepare = function prepare() {
    this.isReady = true;
    var doe = document.documentElement;
    if (!doe.id) {
      doe.id = 'rehtml-' + (+new Date()).toString(36);
    }
    this.namespace = '#' + doe.id;
    var fn = void 0;
    while ((fn = this.readyTask.shift()) != null) {
      // eslint-disable-line
      fn();
    }
  };

  StyleProcessor.prototype.createCss = function createCss(selector, styles) {
    var _this2 = this;

    if (!styles) {
      return '';
    }
    if (this.namespace && selector[0] === '.') {
      selector = this.namespace + ' ' + selector;
    }
    if ({}.toString.call(styles) === '[object String]') {
      if (/:root/ig.test(styles)) {
        return styles.replace(/:root/ig, selector);
      }
      return selector + '{' + styles + '}';
    }
    if (styles.default) {
      var css = [];
      css.push(selector + '{' + (0, _tocss2.default)(styles.default) + '}');
      ['hover', 'focus', 'active'].forEach(function (state) {
        if (styles.hasOwnProperty(state)) {
          var selectorStr = _this2.designMode ? selector + ':' + state + ',' + selector + '.-pseudo-' + state : selector + ':' + state;
          css.push(selectorStr + '{' + (0, _tocss2.default)(styles[state]) + '}');
        }
      });
      return css.join('\n');
    }

    return selector + '{' + (0, _tocss2.default)(styles) + '}';
  };

  StyleProcessor.prototype.addCssText = function addCssText(text) {
    var i = this.cssCollection.indexOf(text);
    if (i < 0) {
      this.cssCollection.push(text);
    }
  };

  StyleProcessor.prototype.clearCollection = function clearCollection() {
    this.cssCollection = [];
  };

  StyleProcessor.prototype.collectStyle = function collectStyle(id, componentName, props) {
    var className = beautifulClassName(componentName, id);
    props.className = className;
    if (props.style) {
      this.addCssText(this.createCss('.' + className, props.style));
    } else if (props.containerStyle) {
      this.addCssText(this.createCss('.' + className, props.containerStyle));
    }
    if (props.itemStyle) {
      this.addCssText(this.createCss('.' + className + '-item', props.itemStyle));
    }
    if (props.pageStyle) {
      this.addCssText(this.createCss('body', props.pageStyle));
    }
  };

  StyleProcessor.prototype.applyStyle = function applyStyle() {
    var css = this.cssCollection.join('\n');
    this.ready(function () {
      return writeGlobalCss(css);
    });
  };

  StyleProcessor.prototype.removeStyle = function removeStyle() {
    removeGlobalCss();
    return this;
  };

  StyleProcessor.prototype.ready = function ready(func) {
    if (this.isReady) {
      func();
      return;
    }
    this.readyTask.push(func);
  };

  StyleProcessor.prototype.createStyleElement = function createStyleElement(from) {
    return _createStyleElement(from);
  };

  return StyleProcessor;
}();

if (!window.__visionStyleProcessor) {
  window.__visionStyleProcessor = new StyleProcessor();
}

exports.default = window.__visionStyleProcessor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_vu-style-processor@1.4.0@@ali/vu-style-processor/build/index.js
// module id = 85
// module chunks = 0